import { THEME_MODES } from '@didaskill/domain/configurations/constants';

import { DARK_THEME } from '../../themes/dark/index';
import { DEFAULT_THEME } from '../../themes/default/index';

export const AVAILABLE_THEMES = {
  [THEME_MODES.DEFAULT]: DEFAULT_THEME,
  [THEME_MODES.DARK]: DARK_THEME,
};
